import dayjs from 'dayjs';

export const setColConfig = (
    config: { title: string; width: string | number }[]
) => {
    return config?.map((item, index) => ({
        title: item.title,
        width: item.width || 'auto',
        key: `col${index + 1}`,
        dataIndex: `col${index + 1}`,
    }));
};

export const getLunarDate = (dateNum: string = '', dateStr: string = '') => {
    const DATE_NUM_REGEX = /ngày ([0-9]+) tháng ([0-9]+(?:\s*\(nhuận\))?) năm ([0-9]+)/;
    const DATE_STR_REGEX = /năm (.*), tháng (.*), ngày (.*)/;
    const num = DATE_NUM_REGEX.exec(dateNum.toLowerCase());
    const str = DATE_STR_REGEX.exec(dateStr.toLowerCase());
    let dayNum: any,
        monthNum: any,
        yearNum: any,
        dayStr: any,
        monthStr: any,
        yearStr: any;
    if (num && num.length > 3) {
        dayNum = num[1];
        monthNum = num[2];
        yearNum = num[3];
    }

    if (str && str.length > 3) {
        dayStr = str[3];
        monthStr = str[2];
        yearStr = str[1];
    }

    return { dayNum, monthNum, yearNum, dayStr, monthStr, yearStr };
};

export const getLunarTime = (
    lunarInHour: { [key: string]: string },
    time: string
) => {
    let _time,
        _lunarInHour: any = {};
    for (let i = 0; i < 24; i++) {
        const prevhour = dayjs()
            .set('hour', i - 1)
            .format('H:00')
            .toString();
        const hour = dayjs().set('hour', i).format('H:00').toString();
        _lunarInHour[hour] = lunarInHour[hour] || lunarInHour[prevhour];
    }
    const now = dayjs(time, 'HH:mm:ss').format('H:00');
    _time = _lunarInHour[now];

    return retriveLunarTime(_time);
};

export const retriveLunarTime = (lunarTime = '') => {
    const HOUR_REGEX = /giờ: (.*), (.*), (hoàng đạo|hắc đạo)/;
    const results = HOUR_REGEX.exec(lunarTime.toLowerCase());
    let hour: any, luckyHour: any, goodDay: any;
    if (results && results.length > 3) {
        hour = results[1];
        luckyHour = results[2];
        goodDay = results[3] === 'hoàng đạo';
    }
    return {
        hour,
        luckyHour,
        goodDay,
    };
};
